import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHFortyFiveNoDownloadPreLogin',
    name: 'IFPageOneHFortyFiveNoDownloadPreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownload/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHFortyFiveNoDownloadLogin' ||
        from.path === '/IFPageOneHFortyFiveNoDownloadLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadLogin',
    name: 'pageOneHFortyFiveNoDownloadLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownload/login.vue'),
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadLoginLoading',
    name: 'pageOneHFortyFiveNoDownloadLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownload/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadLeaveInfo',
    name: 'pageOneHFortyFiveNoDownloadLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownload/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadResult',
    name: 'pageOneHFortyFiveNoDownloadResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownload/result.vue'),
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadLoading',
    name: 'pageOneHFortyFiveNoDownloadLoading',
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownload/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadLoginSecond',
    name: 'pageOneHFortyFiveNoDownloadLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownload/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadOnline',
    name: 'pageOneHFortyFiveNoDownloadOnline',
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownload/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHFortyFiveNoDownloadLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadNoProducts',
    name: 'pageOneHFortyFiveNoDownloadNoProducts',
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownload/noProducts.vue'),
    meta: {
      title: projectName,
    },
  },
  /*{
    path: '/IFPageOneHFortyFiveNoDownloadCar',
    name: 'pageOneHFortyFiveNoDownloadCar',
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownload/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadCarDetails',
    name: 'pageOneHFortyFiveNoDownloadCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownload/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },*/
  {
    path: '/IFPageOneHFortyFiveNoDownloadBlank',
    name: 'pageOneHFortyFiveNoDownloadBlank',
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownload/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadOnlineTab',
    name: 'pageOneHFortyFiveNoDownloadOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownload/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortyFiveNoDownloadOnlineAd',
    name: 'pageOneHFortyFiveNoDownloadOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneHFortyFiveNoDownload/onlineAd.vue'),
    meta: {
      title: projectName,
    },
  },
];
